import script from "./ListarDocumentos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarDocumentos.vue?vue&type=script&setup=true&lang=js"

import "./ListarDocumentos.vue?vue&type=style&index=0&id=2564a7a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2564a7a0"]])

export default __exports__